import { createElement, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { translationKeys } from "../../../../models/app-translation-keys";
import { useStore } from "../../../../stores/StoreContext";
import { sharedDialog } from "../../../Shared/Components/Dialogs/SharedDialog";
import { BugReportDialogContent } from "./BugReportDialogContent/BugReportDialogContent";
import { bugReportDialogFooterActions } from "./bugReportDialogFooter";
import { IBugReportDialogState } from "./bugReportDialogTypes";

import "./BugReportDialog.scss";

interface IBugReportDialogProps {
  isVisible: boolean;
  onHide(): void;
}

export const useBugReportDialog = (props: IBugReportDialogProps): void => {
  const { t } = useTranslation();
  const { userStore } = useStore();

  const keys = translationKeys.bugReport;
  useEffect(() => {
    if (!props.isVisible) {
      return;
    }

    sharedDialog.openSharedDialog({
      title: t(keys.dialogTitle),
      size: "small",
      onClose: () => props.onHide(),
      sharedState: {
        isValid: false,
        formData: {
          summary: "",
          steps: "",
          actual: "",
          moreInfo: "",
        },
      } satisfies IBugReportDialogState,
      customContent: createElement(BugReportDialogContent),
      footerActions: bugReportDialogFooterActions({
        onHide: props.onHide,
        userDisplayName: userStore.userInfo?.displayName,
        userEmail: userStore.userInfo?.email,
      }),
      className: "bug-report-dialog",
      customDismissBehavior: { closeIcon: true, escape: true, outsideClick: false },
    });
  }, [props.isVisible]);
};
